import * as React from 'react'

export const NonceContext = React.createContext<string>('')
export const NonceProvider = NonceContext.Provider
export const useNonce = () => {
  // Be defensive - Layout component may be called before context is ready
  // Return empty string if context is null (React Router v7.9.3+ behavior)
  return React.useContext(NonceContext) ?? ''
}
